/**
 * 资讯模块的公共逻辑 —— Web / Pad / Mobile 共用
 *
 * 分类接口只返回有已发布文章的分类；「全部」是前端固定项，
 * 没有有效分类时整个 Tab 行都不展示（不再补「全部」）。
 */

/** 「全部」是前端固定项，不依赖接口 */
export const ALL_CATEGORY = { value: "all", label: "全部" };

/**
 * 合并「全部」与接口分类：
 * - 没有有效分类时返回空数组，不再补「全部」；
 * - 接口若返回 all / 全部，跳过，避免和固定项重复；
 * - 按 value 去重，保持接口顺序；
 * - 空 value / 空 label 直接丢弃。
 */
export function buildCategoryTabs(options) {
  const seen = new Set([ALL_CATEGORY.value]);
  const validOptions = [];

  (Array.isArray(options) ? options : []).forEach((item) => {
    const value = item?.value == null ? "" : String(item.value).trim();
    const label = item?.label == null ? "" : String(item.label).trim();
    if (!value || !label) return;
    if (value === ALL_CATEGORY.value || label === ALL_CATEGORY.label) return;
    if (seen.has(value)) return;
    seen.add(value);
    validOptions.push({ value, label });
  });

  if (!validOptions.length) return [];

  return [ALL_CATEGORY, ...validOptions];
}

/**
 * 资讯发布时间按北京时间格式化为 YYYY-MM-DD。
 * 后端给 epoch 毫秒，这里 +8h 后用 UTC 字段取日期，避免浏览器本地时区影响。
 */
export function formatNewsPublishDate(timestamp) {
  if (timestamp === null || timestamp === undefined || timestamp === "") return "";

  const ms = Number(timestamp);
  if (!Number.isFinite(ms) || ms <= 0) return "";

  const date = new Date(ms + 8 * 60 * 60 * 1000);
  if (Number.isNaN(date.getTime())) return "";

  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(
    date.getUTCDate()
  )}`;
}
